export type ImageWithAltType = {
  src: string;
  alt: string;
};

const generateImageAlt = (title: string, imageIndex: number) =>
  imageIndex ? `${title} - Photo ${imageIndex + 1}` : title;

export default (images: string[], title: string): ImageWithAltType[] =>
  images.map((src, index) => ({ src, alt: generateImageAlt(title, index) }));
